import "core-js/modules/es.number.constructor.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4d1156da"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "apply-requisition"
};
var _hoisted_2 = {
  class: "list py-3"
};
var _hoisted_3 = {
  class: "materialItem"
};
var _hoisted_4 = {
  class: "title"
};
var _hoisted_5 = {
  class: "info"
};
var _hoisted_6 = {
  class: "info"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "mr-1"
  }, "出库数量：", -1);
});
var _hoisted_8 = {
  class: "info"
};
var _hoisted_9 = {
  class: "footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_field = _resolveComponent("van-field");
  var _component_van_cell_group = _resolveComponent("van-cell-group");
  var _component_van_stepper = _resolveComponent("van-stepper");
  var _component_van_button = _resolveComponent("van-button");
  var _component_van_cell = _resolveComponent("van-cell");
  var _component_retrieval_type_popup = _resolveComponent("retrieval-type-popup");
  var _component_collection_item_type_popup = _resolveComponent("collection-item-type-popup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_cell_group, {
    inset: ""
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_field, {
        modelValue: _ctx.params.warehouse_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _ctx.params.warehouse_name = $event;
        }),
        label: "仓库：",
        readonly: "",
        "input-align": "right",
        placeholder: "请选择仓库",
        onClick: _ctx.selectWarehouse
      }, null, 8, ["modelValue", "onClick"]), _createVNode(_component_van_field, {
        modelValue: _ctx.info.release_type,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _ctx.info.release_type = $event;
        }),
        label: "出库类型：",
        readonly: "",
        "input-align": "right",
        placeholder: "请选择出库类型",
        onClick: _ctx.openRetrievalTypePopup
      }, null, 8, ["modelValue", "onClick"]), _createVNode(_component_van_field, {
        modelValue: _ctx.info.oa_type,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return _ctx.info.oa_type = $event;
        }),
        readonly: "",
        label: "领用物品类型：",
        "input-align": "right",
        placeholder: "请选择领用物品类型",
        onClick: _ctx.openCollectionItemTypePopup
      }, null, 8, ["modelValue", "onClick"]), _createVNode(_component_van_field, {
        modelValue: _ctx.params.contract_name,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return _ctx.params.contract_name = $event;
        }),
        readonly: "",
        label: "领用员工：",
        "input-align": "right",
        placeholder: "请选择领用员工",
        onClick: _ctx.selectStaff
      }, null, 8, ["modelValue", "onClick"]), _createVNode(_component_van_field, {
        modelValue: _ctx.params.dept_name,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return _ctx.params.dept_name = $event;
        }),
        readonly: "",
        label: "所属部门：",
        "input-align": "right",
        placeholder: "请选择所属部门"
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: _ctx.params.remark,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
          return _ctx.params.remark = $event;
        }),
        type: "textarea",
        rows: "1",
        autosize: "",
        label: "领用说明：",
        "input-align": "right",
        placeholder: "请输入领用说明"
      }, null, 8, ["modelValue"])];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_cell_group, {
    inset: ""
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.params.materials, function (item, index) {
        return _openBlock(), _createBlock(_component_van_cell, {
          clickable: "",
          key: item.id
        }, {
          title: _withCtx(function () {
            return [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(item.stone_name) + _toDisplayString(item.stone_specifications ? "/".concat(item.stone_specifications) : ''), 1), _createElementVNode("div", _hoisted_5, "库存数量：" + _toDisplayString(item.stone_stock), 1), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_van_stepper, {
              modelValue: item.release_nums,
              "onUpdate:modelValue": function onUpdateModelValue($event) {
                return item.release_nums = $event;
              },
              max: Number(item.stone_stock),
              min: 0.001,
              "decimal-length": "3",
              step: "1"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "max"])]), _createElementVNode("div", _hoisted_8, "单位：" + _toDisplayString(item.release_unit), 1)])];
          }),
          "right-icon": _withCtx(function () {
            return [_createVNode(_component_van_button, {
              round: "",
              plain: "",
              class: "deleteBtn",
              onClick: function onClick($event) {
                return _ctx.deleteMaterial(index);
              }
            }, {
              default: _withCtx(function () {
                return [_createTextVNode("删除")];
              }),
              _: 2
            }, 1032, ["onClick"])];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_button, {
    class: "addBtn",
    color: "#FFAF37",
    round: "",
    type: "primary",
    onClick: _ctx.toAddMaterials
  }, {
    default: _withCtx(function () {
      return [_createTextVNode("新增物料")];
    }),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_van_button, {
    loading: _ctx.btnDisabled,
    round: "",
    type: "primary",
    onClick: _ctx.submit,
    "loading-type": "spinner",
    "loading-text": "提交中"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode("提交")];
    }),
    _: 1
  }, 8, ["loading", "onClick"])]), _createVNode(_component_retrieval_type_popup, {
    ref: "retrievalTypePopupRef",
    onConfirmType: _ctx.confirmRetrievalTypePopup
  }, null, 8, ["onConfirmType"]), _createVNode(_component_collection_item_type_popup, {
    ref: "collectionItemTypePopupRef",
    onConfirmType: _ctx.confirmCollectionItemTypePopup
  }, null, 8, ["onConfirmType"])]);
}